module.exports = __webpack_public_path__ + "img/rule.72fb66a6.png";